import { VStack } from '@chakra-ui/layout'
import { Box, Text as ChakraText } from '@chakra-ui/react'
import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { GrImage as GrImageIcon } from 'react-icons/gr'
import { MdAlarmAdd, MdOutlineAccountBalanceWallet, MdOutlineSubscriptions } from "react-icons/md"
import { RiBillLine } from 'react-icons/ri'
import styled, { createGlobalStyle } from 'styled-components'
import { colors } from '../../../ui-kit'
import { SideBar } from '../../layouts/Base'
import { SideBarItem } from '../../layouts/Base/SideBar'
import { UserContext } from '../../providers'


const GrImage = styled(GrImageIcon)`
  path {
    stroke: ${props => props.stroke};
  }
`

const ActiveLinkStyles = createGlobalStyle`
  .active-link {
    ${GrImage} {
      path {
        stroke: ${colors.appSlate};
      }
    }

    :not(${GrImage}) {
      svg {
        fill: ${colors.appSlate};
      }
    }
    p {
      color: ${colors.appSlate};
    }
  }
`
const BillingSideMenu = (): React.ReactElement => {
  const { t } = useTranslation()
  const { user } = useContext(UserContext)

  return (
    <SideBar heading={t('billing_info', 'Billing Info')}>
      <ActiveLinkStyles />
      <VStack
        overflow="auto"
        h="100%"
        spacing="1em"
        padding="1.5em 0.75em 1.5em"
      >
        {user?.billingDetails.billTo === 'self' ? (
          <SideBarItem to="/billing/details" activeClassName="active-link">
            <Box margin="1rem">
              <RiBillLine fontSize="2rem" fill={colors.appBattleshipGrey} />
            </Box>
            <ChakraText
              fontSize="md"
              fontWeight="500"
              color="appBattleshipGrey"
              lineHeight="4rem"
            >
              {t('billing_details', 'Billing Details')}
            </ChakraText>
          </SideBarItem>
        ) : null}
        <SideBarItem to="/billing/subscriptions" activeClassName="active-link">
          <Box margin="1rem">
            <MdOutlineSubscriptions fontSize="2rem" fill={colors.appBattleshipGrey} />
          </Box>
          <ChakraText
            fontSize="md"
            fontWeight="500"
            color={colors.appBattleshipGrey}
            lineHeight="4rem"
          >
            {t('subscription', 'Subscription')}
          </ChakraText>
        </SideBarItem>
        {user?.billingDetails.billTo === 'self' ? (
          <SideBarItem to="/billing/alerts" activeClassName="active-link">
            <Box margin="1rem">
              <MdAlarmAdd fontSize="2rem" fill={colors.appBattleshipGrey} />
            </Box>
            <ChakraText
              fontSize="md"
              fontWeight="500"
              color={colors.appBattleshipGrey}
              lineHeight="4rem"
            >
              {t('billing_alerts', 'Billing Alerts')}
            </ChakraText>
          </SideBarItem>
        ) : null}
        {user?.billingDetails.billTo === 'self' ? (
          <SideBarItem to="/billing/credit-balance" activeClassName="active-link">
            <Box margin="1rem">
              <MdOutlineAccountBalanceWallet fontSize="2rem" fill={colors.appBattleshipGrey} />
            </Box>
            <ChakraText
              fontSize="md"
              fontWeight="500"
              color={colors.appBattleshipGrey}
              lineHeight="4rem"
            >
              {t('credit_balance', 'Credit balance')}
            </ChakraText>
          </SideBarItem>
        ) : null}
      </VStack>
    </SideBar>
  )
}

export default BillingSideMenu
